module.exports = require("dyna-guid");